import axiosInstance from '../../../core/api/interceptors/axiosInterceptor';

const BASE_URL = 'PaymentMethod';

/**
 * Get all payment methods
 */
export const getAllPaymentMethods = async () => {
  try {
    const response = await axiosInstance.get(`${BASE_URL}/get-all`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

/**
 * Get only active payment methods
 */
export const getActivePaymentMethods = async () => {
  try {
    const response = await axiosInstance.get(`${BASE_URL}/get-active`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

/**
 * Get payment method by ID
 */
export const getPaymentMethodById = async (id) => {
  try {
    const response = await axiosInstance.get(`${BASE_URL}/${id}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

/**
 * Create a new payment method
 * @param {Object} data - { Name: string }
 */
export const createPaymentMethod = async (data) => {
  try {
    const response = await axiosInstance.post(`${BASE_URL}/create`, data);
    return response.data;
  } catch (error) {
    throw error;
  }
};

/**
 * Update an existing payment method
 * @param {number} id - Payment method ID
 * @param {Object} data - { Name: string }
 */
export const updatePaymentMethod = async (id, data) => {
  try {
    const response = await axiosInstance.put(`${BASE_URL}/update/${id}`, data);
    return response.data;
  } catch (error) {
    throw error;
  }
};

/**
 * Delete a payment method
 * @param {number} id - Payment method ID
 */
export const deletePaymentMethod = async (id) => {
  try {
    const response = await axiosInstance.delete(`${BASE_URL}/delete/${id}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};
